import ApplicationSerializer from './application';

export default class AnnouncementResponseOptionSerializer extends ApplicationSerializer {}
